<form [formGroup]="form">
	<mat-list-item class="input">
		<input
			matInput
			type="text"
			placeholder="Enter terminal"
			formControlName="terminalControl"
			(keyup.enter)="filter()" />
	</mat-list-item>
</form>
